export const MASTER_ROW_TYPE = 'group-header';

export const STATUS_BUCKETS = {
  ASSIGNED: 'assigned',
  UNASSIGNED: 'unassigned',
  COMPLETED: 'completed',
} as const;

export const MOVE_TYPES = {
  SWAP: 'swap',
  DROP: 'drop',
  HOOK: 'hook',
} as const;

export const ROW_TYPES = {
  GROUP_HEADER: MASTER_ROW_TYPE,
  GROUPED: 'grouped',
} as const;

export const TRAILER_SLOTS = {
  TRAILER_1: 'trailer1',
  TRAILER_2: 'trailer2',
} as const;

/** Ordered slot list for iteration in normalize/payload helpers. */
export const TRAILER_SLOT_VALUES = [
  TRAILER_SLOTS.TRAILER_1,
  TRAILER_SLOTS.TRAILER_2,
] as const;

export const DETAIL_PANEL_MAX_HEIGHT = 200;
export const DETAIL_PANEL_VERTICAL_PADDING = 20;
export const DETAIL_ROW_HEIGHT = 30;
export const DETAIL_HEADER_HEIGHT = 30;
export const DETAIL_GRID_BORDER_HEIGHT = 2;
export const DETAIL_SCROLLBAR_HEIGHT = 17;
export const DETAIL_MAX_BODY_HEIGHT =
  DETAIL_PANEL_MAX_HEIGHT -
  DETAIL_PANEL_VERTICAL_PADDING -
  DETAIL_GRID_BORDER_HEIGHT -
  DETAIL_SCROLLBAR_HEIGHT;
export const DETAIL_PANEL_ANCHOR_FIELD = 'shipperName';
export const DETAIL_GRID_TITLE = 'TrailerMovesDetailGrid';
export const DETAIL_GRID_THEME_FALLBACK = 'modernLight';

export type StatusBucket = (typeof STATUS_BUCKETS)[keyof typeof STATUS_BUCKETS];
export type MoveType = (typeof MOVE_TYPES)[keyof typeof MOVE_TYPES];
export type TrailerSlot = (typeof TRAILER_SLOTS)[keyof typeof TRAILER_SLOTS];
